// Shared quotation constants
const STATUS_COLORS = {
  draft: 'bg-gray-100 text-gray-700',
  pending_approval: 'bg-amber-100 text-amber-700',
  approved: 'bg-blue-100 text-blue-700',
  released: 'bg-emerald-100 text-emerald-700',
  open: 'bg-purple-100 text-purple-700',
  won: 'bg-green-100 text-green-700',
  partially_won: 'bg-teal-100 text-teal-700',
  lost: 'bg-red-100 text-red-700',
  expired: 'bg-gray-100 text-gray-500',
  cancelled: 'bg-gray-100 text-gray-500',
};

const CURRENCIES = ['INR', 'USD', 'EUR', 'GBP', 'JPY', 'AED', 'SGD'];
const UOM_OPTIONS = [
  { value: 'pcs', label: 'Per Piece', multiplier: 1 },
  { value: 'kgs', label: 'Per Kg', multiplier: 1 },
  { value: 'per_100', label: 'Per 100 Pcs', multiplier: 100 },
  { value: 'per_1000', label: 'Per 1000 Pcs', multiplier: 1000 },
];

// Price Unit options for flexible pricing
const PRICE_UNIT_OPTIONS = [
  { value: 1, label: '1 (Pc)' },
  { value: 100, label: '100' },
  { value: 1000, label: '1000' },
];

// Price basis label for a quotation line: 'Kg' for weight-based lines, else pieces
const priceBasisLabel = (item = {}) => {
  if (item.uom === 'kgs') return 'Kg';
  if (item.price_unit === 100) return '100 pcs';
  if (item.price_unit === 1000) return '1000 pcs';
  return 'pc';
};

const LOST_REASONS = [
  { value: 'price_high', label: 'Price Too High' },
  { value: 'lead_time', label: 'Lead Time Too Long' },
  { value: 'quality_concerns', label: 'Quality Concerns' },
  { value: 'competitor', label: 'Lost to Competitor' },
  { value: 'budget_cut', label: 'Customer Budget Cut' },
  { value: 'project_cancelled', label: 'Project Cancelled' },
  { value: 'no_response', label: 'No Response' },
  { value: 'other', label: 'Other' },
];

export { STATUS_COLORS, CURRENCIES, UOM_OPTIONS, PRICE_UNIT_OPTIONS, LOST_REASONS, priceBasisLabel };
